import React from 'react';

function Inner({children}) {
   return <div className="inner">{children}</div>
}

export default Inner;